import React, { useState,useEffect } from 'react';
import './classes/ManageEmailsEdit.css';
import SalespersonSidebar from './SalespersonSidebar';
import { configData } from "../config";
import Editor, { 
  BtnBold,
  BtnItalic,
  BtnRedo,
  BtnUndo,
  Toolbar
} from 'react-simple-wysiwyg';
import {useNavigate, useParams, useSearchParams } from 'react-router-dom';


const ManageEmailsEdit = () => {
  const initialForm = {
    id:id,
    editTitle: '',
    editEmailkey: '',
    editEmailcode: '',
    emailedit_field_active: 1,
    emailedit_field_type: '5',
    editSummary: '',
    editBody: '',
    editDescriptive:'',
    version:'',
    import_sendgrid_activity:0,
    parent: []
  };

  const parentOptions = [
    "Agent",
    "Baseball",
    "Basketball",
    "Football",
    "Hockey",
    "Soccer",
    "All Sports",
    "Advanced Certificates",
    "Agent Certification",
    "Conferences",
    "CUC",
    "CUI",
    "Cricket",
    "Esports",
    "Motorsports",
    "Rugby"
  ];

const[searchParams,setSearchParams] = useSearchParams();
  const destination = searchParams.get("destination");
  const [formData, setFormData] = useState(initialForm);
  const[userLoggedInRoles,setUserLoggedInRoles] = useState([]);
  const [showSummary, setShowSummary] = useState(false);
  const [useRichEditor, setUseRichEditor] = useState(true);
  const [errors, setErrors] = useState({});
  const [showContent, setShowContent] = useState(false);
  const [PreviewFields, setPreviewFields] = useState(false);
  const [viewChanges,setViewChanges] = useState(false);
  const [formDataSnapshot, setFormDataSnapshot] = useState(null)
  const [originalData, setOriginalData] = useState(null);
  const [previewData, setPreviewData] = useState(null);

  const [disabled, setDisabled] = useState(false);
  const [buttontext, setButtonText] = useState("Save");

        const handlePreviewClick = () => {
  const body = formData.editBody;
  const summary = formData.editSummary;
  const title = formData.editTitle;

  const hasSummary = summary && summary.trim() !== '';

  setPreviewFields(true);
  setViewChanges(false);

  setPreviewData({
    summary: hasSummary ? summary : '',
    body: body,
    title: title
  });
};

const fieldDiff = (label, oldValue = '', newValue = '') => {
  const oldLines = oldValue.split('\n');
  const newLines = newValue.split('\n');
  const maxLength = Math.max(oldLines.length, newLines.length);

  let body = `
    <tr class="diff-section-title">
      <td colspan="4">Changes to <em>${label}</em></td>
    </tr>
  `;

  for (let i = 0; i < maxLength; i++) {
    const oldLine = (oldLines[i] || '').trim();
    const newLine = (newLines[i] || '').trim();

    if (oldLine !== newLine) {
      body += `
        <tr>
          <td colspan="2"><span class="diff-removed">- {oldLine ? renderWords(oldWords, newWords, true) : <em>Empty</em>}</span></td>
          <td colspan="2"><span class="diff-added">+ {newLine ? renderWords(newWords, oldWords, false) : <em>Empty</em>}</span></td>
        </tr>
      `;
    }
  }

  return body;
};




  const navigate = useNavigate();
  var {id} = useParams();
  const app_url = configData.APP_URL;
  // const handleChange = (field) => (e) => {
  //   const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
  //   setFormData((prev) => ({ ...prev, [field]: value }));
  // };
  const handleChange = (field) => (e) => {
    const target = e.target;

    let value;
    
    if (target.multiple) {
      value = Array.from(target.selectedOptions, (option) => option.value);
    }
    else if (target.type === "checkbox") {
      value = target.checked;
    }
    else {
      value = target.value;
    }

    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  useEffect(() => {
     retrieveEmailDetailedView();
     getuserloggedinroles();
    },[]);
async function  retrieveEmailDetailedView() {
    
    
    const response = await fetch(
      app_url+'emails/getemaildetailedview?id='+id,
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.msg == "Success") {
      // setFormData({
      //   id:responsedata.data.result.id,
      //  editTitle: responsedata.data.result.subject,
      // editEmailkey: responsedata.data.result.emailkey,
      // editEmailcode: responsedata.data.result.emailcode,
      // emailedit_field_active: responsedata.data.result.status,
      // emailedit_field_type: responsedata.data.result.type,
      // editSummary: '',
      // editDescriptive:responsedata.data.result.descriptive_text,
      // editBody: responsedata.data.result.body,
      //       });
       const updatedForm = {
  id: responsedata.data.result.id,
  editTitle: responsedata.data.result.subject,
  editEmailkey: responsedata.data.result.emailkey,
  editEmailcode: responsedata.data.result.emailcode,
  emailedit_field_active: responsedata.data.result.status,
  emailedit_field_type: responsedata.data.result.type,
  editSummary: '',
  editDescriptive: responsedata.data.result.descriptive_text,
  editBody: responsedata.data.result.body,
  version:responsedata.data.result,
  parent: responsedata.data.result.parent,
  import_sendgrid_activity: Number(responsedata.data.result.import_sendgrid_activity ?? 0),
};

setFormData(updatedForm);
setOriginalData(updatedForm); 
    
    }
  
  }
    async function getuserloggedinroles() {
   
         try {
            const response = await fetch(
                app_url+'viewprofile/getuserloggedinrolesid',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
               setUserLoggedInRoles(responsedata.data.roles);
            } 
        } catch (err) {
            
         }
       
  }
  
  const validate = () => {
   
     const errors = [];
    if (!formData.editTitle) {
       
      errors.push('Subject is required');
    }
    if (!formData.editEmailkey) errors.push('Emailkey is required');
    if (!formData.editEmailcode) errors.push('EmailCode is required');
   
    
     return errors; 
  };
    const handleReadMore = (e) => {
    e.preventDefault();
    setShowContent(!showContent);
  };
  const stripHtml = (html) => {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
};

const summaryHasText = stripHtml(formData.editSummary).trim().length > 0;
const bodyHasBreak = formData.editBody.includes('<!--break-->');
  const handleSubmit = async event => {
    event.preventDefault();
   const newErrors = validate(formData);
    setErrors(newErrors);
   
    if (Object.keys(newErrors).length === 0) {
      setDisabled(true);
      setButtonText("Saving..."); 
      const postData = formData;
      const response = await fetch(app_url + 'emails/updateemail', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if(data.data.msg == "Success") {
        setButtonText("Save");
        setDisabled(false);
        if(destination != '' && destination != null) {
          
        navigate('/'+destination, { state: { message: data.data.result } });
        } else {
        
          navigate('/emails/'+id+'/view', { state: { message: data.data.result } });

        }
      } 
       if(data.data.msg == "Error") {
        setButtonText("Save");
        setDisabled(false);
        setErrors(data.data.result);
        window.scrollTo(0, 0);
       }
       
    } else {
      window.scrollTo(0, 0);
    }
  };
  const handleDelete = async () => {
    const confirmed = window.confirm("Are you sure you want to delete?");
          if (confirmed) {
           const response = await fetch(
          app_url+'emails/deleteemail?id='+id,
              {
                  method: "GET",
          
                  headers: {
                  'Content-Type': 'application/json',
                  },
              }
          )
          const responsedata = await response.json();
          if(responsedata.data.msg == "Success") {
              navigate('/manage-emails', { state: { message: responsedata.data.result } })     
           }
       
          }
  };
  return (
   
        <div>
           {errors.length > 0 && (
          <div className="set-message-error" style={{ background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`,padding:"10px 10px 10px 42px"}}>
           {errors.map((item, index) => {
           return <>{item}<br /></>
          
        })}  
          </div>
        )}
          {viewChanges && (
<div className='diff-table-wrapper'>
  <table className="diff-table">
  <colgroup>
    <col className="diff-marker" />
    <col className="diff-content" />
    <col className="diff-marker" />
    <col className="diff-content" />
  </colgroup>
  <thead>
    <tr>
      <th colSpan="2">Original</th>
      <th colSpan="2">Changes</th>
    </tr>
  </thead>
  <tbody>
    {!formDataSnapshot || !originalData ? (
      <tr className="no-changes">
        <td className="diff-section-title" colSpan="4">No visible changes</td>
      </tr>
    ) : (
      (() => {
        const diffs = [];

    
        const compareField = (label, oldValue = '', newValue = '') => {
  if (oldValue === newValue) return null;

  const oldLines = (oldValue ?? '').split('\n');
  const newLines = (newValue ?? '').split('\n');
  const maxLines = Math.max(oldLines.length, newLines.length);

  const rows = [
    <tr className="diff-section-title" key={`${label}-title`}>
      <td colSpan="4">Changes to <em>{label}</em></td>
    </tr>
  ];

  for (let i = 0; i < maxLines; i++) {
    const oldLine = (oldLines[i] || '').trim();
    const newLine = (newLines[i] || '').trim();

    if (oldLine !== newLine) {
      const oldWords = oldLine.split(/\s+/);
      const newWords = newLine.split(/\s+/);
      const maxWords = Math.max(oldWords.length, newWords.length);

      const renderWords = (wordsA, wordsB, isOld) =>
        wordsA.map((word, idx) => {
          const matchingWord = wordsB[idx] || '';
          const changed = word !== matchingWord;

          return (
            <span
              key={`${label}-${isOld ? 'old' : 'new'}-${i}-${idx}`}
              style={changed ? {
                color: isOld ? 'red' : 'red',
                borderRadius: '4px',
                padding: '0 3px',
                fontWeight:'bold'
              } : {}}
            >
              {word}
              {' '}
            </span>
          );
        });

      rows.push(
        <tr key={`${label}-${i}`}>
          <td><span>-</span></td>
          <td className="diff-removed">{renderWords(oldWords, newWords, true)}</td>
          <td><span>+</span></td>
          <td className="diff-added">{renderWords(newWords, oldWords, false)}</td>
        </tr>
      );
    }
  }

  return rows;
};


        diffs.push(...(compareField('Subject', originalData.editTitle, formDataSnapshot.editTitle) || []));
        diffs.push(...(compareField('Body', originalData.editBody, formDataSnapshot.editBody) || []));
        diffs.push(...(compareField('EmailKey', originalData.editEmailkey, formDataSnapshot.editEmailkey) || []));
        diffs.push(...(compareField('EmailCode', originalData.editEmailcode, formDataSnapshot.editEmailcode) || []));
        diffs.push(...(compareField('Type', originalData.emailedit_field_type, formDataSnapshot.emailedit_field_type) || []));
        diffs.push(...(compareField('Descriptive Text', originalData.editDescriptive, formDataSnapshot.editDescriptive) || []));

        return diffs.length > 0 ? diffs : (
          <tr className="no-changes">
            <td className="diff-section-title" colSpan="4">No visible changes</td>
          </tr>
        );
      })()
    )}
  </tbody>
</table>
</div>
)}



          {PreviewFields && (
            <>
          <div className="messages status" style={{ background: `#f0f8eb url("/images/message-ok.png") no-repeat`,backgroundPosition: '10px 10px' }}>

  The trimmed version of your post shows what your post looks like when promoted to the main page or when exported for syndication.
  <span>
    You can insert the delimiter "&lt;!--break--&gt;" (without the quotes) to fine-tune where your post gets split.
  </span>
</div>

         <div className="preview-container">
          <div className='preview-trimmed'>
  <h4 className="preview-heading">
    <span className="preview-square"></span> Preview trimmed version
  </h4>

  <div className="email-teaser">
    <h2 className="email-title">
      <a href="/full-email-page">{previewData.title}</a>
    </h2>

    <div className="email-teaser-block1">
      <div className="email-teaser-block2">
        {/* {formData.editBody.includes('<!--break-->') && (
       <div
    className="preview-body-content"
    dangerouslySetInnerHTML={{
      __html: formData.editBody.split('<!--break-->')[0]
    }}
  />)} */}
  {/* {(summaryHasText || bodyHasBreak) && (

    <div
      className="preview-body-content"
      dangerouslySetInnerHTML={{
        __html: summaryHasText
          ? formData.editSummary
          : formData.editBody.split('<!--break-->')[0]
      }}
    />

)} */}
{(previewData.summary?.trim() || previewData.body.includes('<!--break-->')) && (
  <div
    className="preview-body-content"
    dangerouslySetInnerHTML={{
      __html: previewData.summary?.trim()
        ? previewData.summary
        : previewData.body.split('<!--break-->')[0]
    }}
  />
)}

      </div>
    </div>

    <div className="read-more-link">
      <a href={"/emails/"+id+"/view"}>Read more</a>
    </div>
  </div>
</div>
 <div className='preview-full'>
  <h4 className="preview-heading">
    <span className="preview-square"></span> Preview full version
  </h4>

  <div className="email-teaser">
    <h2 className="email-title">
   <strong>Body:</strong>
     
    </h2>

    <div className="email-teaser-block1">
      
      <div className="email-teaser-block2">
         <span dangerouslySetInnerHTML={{__html: formData.editBody}}></span>
      </div>
    </div>

   
  </div>
</div>

</div>
</>
)}

          <form>
            <div>
              <div className="emailedit-form-item">
                <label htmlFor="edit_title">
                  Subject <span className="form-required" title="This field is required.*">*</span>
                </label>
                <input
                  type="text"
                  id="edit_title"
                  name="editTitle"
                  value={formData.editTitle}
                  className='email-input-field'
                  // size="60"
                  maxLength="255"
                  onChange={handleChange('editTitle')}
                />
              </div>

              <div className="emailedit-format-wrapper">
                <div>
                  {showSummary && (
                    <div className="emailedit-form-item">
                      <label htmlFor="edit_summary">
                        Summary <span>(<a className="emailedit-summary" href="#" onClick={(e) => { e.preventDefault(); setShowSummary(false); }}>Hide Summary</a>)</span>
                      </label>
                      <>
                      <Editor value={formData.editSummary} onChange={(e) => setFormData((prev) => ({ ...prev, editSummary: e.target.value })) } />
                        
                      </>
                      <div className="description">Leave blank to use trimmed value of full text as the summary.</div>
                    </div>
                  )}

                  <div className="emailedit-form-item">
                    <label htmlFor="edit_body">
                      Body <span>(<a className="emailedit-body" href="#" onClick={(e) => { e.preventDefault(); setShowSummary(true); }}>Edit Summary</a>)</span>
                    </label>
                    <>
                      {useRichEditor ? (
                        <>
                          <Editor value={formData.editBody} onChange={(e) => setFormData((prev) => ({ ...prev, editBody: e.target.value })) } />
                        </>
                      ) : (
                        <>
                          <textarea
                            id="edit_body"
                            cols="60"
                            rows="20"
                            value={formData.editBody}
                            onChange={(e) => setFormData((prev) => ({ ...prev, editBody: e.target.value }))}
                          />
                          <div className="grippie" style={{ background: `#eee url("/images/grippie.png") no-repeat center 2px` }}></div>
                         
                        </>
                      )}
                       <a href="#" onClick={(e) => { e.preventDefault(); setUseRichEditor(!useRichEditor); }}>Switch to rich text editor</a>
                    </>
                  </div>
                </div>
              </div>

              <div className="emailedit-form-item">
                <label htmlFor="edit_emailkey">EmailKey <span className="form-required" title="This field is required.*">*</span></label>
                <input
                  type="text"
                  id="edit_emailkey"
                  name="editEmailkey"
                  value={formData.editEmailkey}
                  className='email-input-field'
                  // size="60"
                  maxLength="255"
                  onChange={handleChange('editEmailkey')}
                />
              </div>

              <div className="emailedit-form-item">
                <label htmlFor="edit_emailcode">EmailCode <span className="form-required" title="This field is required.*">*</span></label>
                <input
                  type="text"
                  id="edit_emailcode"
                  name="editEmailcode"
                  value={formData.editEmailcode}
                   className='email-input-field'
                  // size="60"
                  maxLength="255"
                  onChange={handleChange('editEmailcode')}
                />
              </div>

              <div className="emailedit-form-item emailedit-form-checkbox">
                <input
                  type="checkbox"
                  id="emailedit-field-active"
                  name="emailedit_field_active"
                  checked={formData.emailedit_field_active}
                  onChange={handleChange('emailedit_field_active')}
                />
                <label htmlFor="emailedit-field-active">Active</label>
              </div>

              <div className="emailedit-form-item emailedit-form-select">
                <label htmlFor="emailedit-field-type">Type</label>
                <select
                  name="emailedit_field_type"
                  className='email-field-select'
                  value={formData.emailedit_field_type}
                  onChange={handleChange('emailedit_field_type')}
                >
                  <option value="">-None-</option>
                  {[...Array(10)].map((_, i) => (
                    <option key={i + 1} value={i + 1}>{i + 1}</option>
                  ))}
                </select>
              </div>

              <div className="emailedit-form-item emailedit-form-select">
                <label htmlFor="emailedit-parent">Email Category</label>
                <select
                  name="parent"
                  className='email-field-select'
                  value={formData.parent}
                  onChange={handleChange('parent')}
                  multiple
                  size={7}
                >
                  <option value="">-None-</option>
                  {parentOptions.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
              <div className="emailedit-form-item">
                <label>
        <input
            type="checkbox"
            name="import_sendgrid_activity"
             checked={Number(formData.import_sendgrid_activity) === 1}
            onChange={(e) =>
                setFormData({
                    ...formData,
                    import_sendgrid_activity: e.target.checked ? 1 : 0,
                })
            }
        />
        {' '} Import SendGrid Activity
    </label>
              </div>
              <div className="emailedit-form-item">
                <label htmlFor="edit_descrpttext">Descriptive Text</label>
                <textarea id="edit_descrpttext" value={formData.editDescriptive} name="editDescriptive"  onChange={handleChange('editDescriptive')} cols="60" rows="5"></textarea>
                <div className="grippie" style={{ background: `#eee url("/images/grippie.png") no-repeat center 2px` }}></div>
              </div>

              <div className="emailedit-form-item">
                {/* <input type="submit" id="edit-submit"  value="Save" className="form-submit" onClick={handleSubmit} /> */}
                <button type="submit" className="form-submit" disabled={disabled} onClick={handleSubmit}>{buttontext}</button>&nbsp;&nbsp;
                  <input 
                  type="button" 
                  id="edit-preview"  
                  value="Preview" 
                  className="form-submit" 
                  onClick={()=> {
                    setPreviewFields(true);
                    setViewChanges(false); 
                    handlePreviewClick();
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                    />
                
                <button
  type="button"
  className="form-submit"
  onClick={() => {
    setFormDataSnapshot(formData); // Capture current form data
    setViewChanges(true);          // Trigger display
    setPreviewFields(false);       // Hide preview if needed
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }}
>
  View Changes
</button>
 
          {(
   
             userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ||
             userLoggedInRoles.includes(configData.ROLE_SAADMIN) 
           ) && (
             <input type="button" className="form-submit" value="Delete" onClick={handleDelete}/>
             )}
              </div>
            </div>
          </form>
          
         
        </div>
     
  );
};

export default ManageEmailsEdit;